document.addEventListener("DOMContentLoaded", function(event) {

    let easySwiper = document.querySelectorAll(".JS-easy-slider"),
        swiper;
    if (typeof(easySwiper) != 'undefined' && easySwiper != null){
        easySwiper.forEach(function(e) {
            let id = e.dataset.id;
            const swiper = new Swiper(e, {
                spaceBetween: 32,
                navigation: {
                    nextEl: ".swiper-controls-" + id + " .swiper-button-next",
                    prevEl: ".swiper-controls-" + id + " .swiper-button-prev",
                },
                pagination: {
                    el: ".swiper-controls-" + id + " .swiper-pagination",
                    type: 'bullets',
                    clickable: true,
                },
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                    },
                    650: {
                        slidesPerView: 2,
                    },
                    980: {
                        slidesPerView: 3,
                    }
                }
            });
        });
    }
});